import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";
import Alpine from "alpinejs";
import { IContextMenuActivate, IContextMenuItem } from "../global";
import htmx from "htmx.org";

const copyUrlPrefix = "copy://";

export default class ContextMenu extends AlpineComponent {
  constructor(
    public x = 0,
    public y = 0,
    public hidden = true,
    public items: IContextMenuItem[] = []
  ) {
    super();
  }

  init() {
    this.hidden = this.$el.classList.contains("hidden");
    this.$watch("x", () => {
      this.$el.style.left = `${this.x}px`;
    });
    this.$watch("y", () => {
      this.$el.style.top = `${this.y}px`;
    });

    Alpine.effect(() => {
      this.hidden = this.items.length === 0;
    });
  }

  reset() {
    this.items = [];
  }

  onContextMenu(e: CustomEvent<IContextMenuActivate>) {
    if (!this.hidden) {
      return;
    }

    this.x = e.detail.source.x;
    this.y = e.detail.source.y;
    e.detail.source.stopPropagation();
    this.items = e.detail.items;

    const selection = window.getSelection();
    const selectedText = selection?.toString().trim() ?? "";
    if (selectedText?.length > 0) {
      this.items = [
        {
          display: "Copy",
          url: copyUrlPrefix + selectedText,
        },
        ...this.items,
      ];
    }

    this.$nextTick(() => {
      const rect = this.$el.getBoundingClientRect();

      if (this.x + rect.width > window.innerWidth) {
        this.x = Math.max(0, window.innerWidth - rect.width);
      }

      if (this.y + rect.height > window.innerHeight) {
        this.y = Math.max(0, window.innerHeight - rect.height);
      }
    });

    // Make sure to dismiss on the next context menu
    document.addEventListener(
      "contextmenu",
      () => {
        this.hidden = true;
      },
      { once: true }
    );
  }

  onClick() {
    this.reset();
  }

  async onSelect(item: IContextMenuItem) {
    const promise = this.execute(item);
    this.reset();
    await promise;
  }

  private execute(item: IContextMenuItem) {
    if (item.url.startsWith(copyUrlPrefix)) {
      return navigator.clipboard.writeText(
        item.url.substring(copyUrlPrefix.length)
      );
    }

    return htmx.ajax("get", item.url, {});
  }
}
